import Flickity from 'flickity';
require('flickity-imagesloaded');

export default (() => {
  function initCarousel(element) {
    if (element) {
      const options = {
        cellSelector: '.carousel__item',
        pageDots: false,
        prevNextButtons: false,
        imagesLoaded: true,
        percentPosition: false
      };

      const carousel = new Flickity.data( element, options);
      const controls = element.parentNode.querySelector('.carousel__controls');
      const buttons = controls && controls.querySelectorAll('button');

      if (buttons) {
        buttons[ 0 ].addEventListener('click', () => {
          carousel.previous();
        });
        buttons[ 1 ].addEventListener('click', () => {
          carousel.next();
        });
      }

      const items = Array.from(element.querySelectorAll(options.cellSelector));
      const columns = element.dataset.maxColumns;
      if (items && items.length) {
        switch (items.length) {
          case 1:
            controls.classList.add('d-none');
            break;
          case 2:
            if (items.length <= columns) {
              controls.classList.add('d-sm-none');
            }
            break;
          case 3:
            if (items.length <= columns) {
              controls.classList.add('d-md-none');
            }
            break;
          case 4:
            if (items.length <= columns) {
              controls.classList.add('d-lg-none');
            }
            break;
        }
      }

      carousel.resize();
    }
  }
  window.addEventListener('load', () => {
    setTimeout(() => {
      const elements = document.querySelectorAll('[data-flickity]');
      Array.from(elements).forEach(element => {
        initCarousel(element);
      });
    }, 0);
  });
})();
